define('Components/AdvantageWidget/js/models/AdvantageWidgetModel',['underscore', 'app', 'ObjectModel', 'moment'],
    function (_, app, ObjectModel, moment){

    var DISCOUNT_TRANSLATION_CONTEXT = 'discount',
        DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ';
    //
    //
    //
    var AdvantageWidgetModel = ObjectModel.extend({
        route: 'apiAdvantageModel',
        initialize:function() {
            var model = this;
            model.set('discounts',[]);
            model.on('sync', model.onUpdateProducts);
        },
        getDiscounts:function(){
            return this.get('discounts');
        },
        onUpdateProducts:function(){
            //
            // formate les discounts lors de la synchronisation
            //
            var model = this,
                discounts = _(this.get('discounts'));
            //
            function formatDate(date){
                var m = moment(moment(date, DATE_FORMAT).toDate());
                return m.format('LL');
            }
            // apply options & string filters over discount datas,
            // for templating purposes
            discounts.each(function(discount){
                var desc='',
                    buttonVisible = false,
                    buttonIcon='cart-mini',
                    buttonLabel = '',
                    buttonDisabled = false,
                    discount_available = discount.available,
                    display_as_voucher = discount.display_as_voucher === '1',
                    end_date = discount.end_date_neolane;

                if (!end_date) {
                    end_date = discount.end_date_web;
                }
                var expirationDate = moment(moment(end_date, DATE_FORMAT).toDate()),
                    expirationDateFormated = expirationDate.format('LL');

                if(discount_available){
                    if (display_as_voucher) {
                        desc = app.t('Code %s valable jusque au %s', DISCOUNT_TRANSLATION_CONTEXT, [discount.code, expirationDateFormated]);
                    }
                }else{
                    switch (discount.no_available){
                        case 2:
                            desc = app.t("Bon déja utilisé le %s", DISCOUNT_TRANSLATION_CONTEXT, [ formatDate(discount.date_use)]);
                            break;
                        case 3:
                            desc = app.t("Ce n'est pas le encore le le moment, un peu de patience", DISCOUNT_TRANSLATION_CONTEXT);
                            break;
                        case 4:
                            desc = discount.description_right_faild;
                            break;
                        case 1:
                        default:
                            desc = app.t('le code %s est invalide ', DISCOUNT_TRANSLATION_CONTEXT, [discount.code ]);
                            break;
                    }
                }
                discount.desc = desc;
                if(display_as_voucher){
                    buttonVisible = true;
                    if (discount_available){
                        buttonLabel = app.t('Ajouter au panier', DISCOUNT_TRANSLATION_CONTEXT);
                    }else{
                        buttonDisabled = true;
                        switch (discount.no_available){
                            case 2:
                                buttonLabel = app.t("déja utilisé", DISCOUNT_TRANSLATION_CONTEXT, [ formatDate(discount.date_use)]);
                                buttonIcon = 'success';
                                break;
                            default:
                                buttonLabel = app.t('pas disponible ', DISCOUNT_TRANSLATION_CONTEXT, [discount.name ]);
                                buttonIcon = 'timer';
                                break;
                        }
                    }
                }
                discount.buttonVisible = buttonVisible;
                discount.buttonIcon = buttonIcon;
                discount.buttonLabel = buttonLabel;
                discount.buttonDisabled = buttonDisabled;
            });
        }
    });

    return AdvantageWidgetModel;

});
